import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageContext";

const NavBar = () => {
  const { lang, setLang, t } = useLanguage();

  const langButtonClass = (code) =>
    lang === code
      ? "text-white font-bold"
      : "text-gray-400 hover:text-white";

  return (
    <nav className="bg-gray-900/60 backdrop-blur-sm text-white py-4 fixed w-full z-40 px-6">
      <div className="container mx-auto flex items-center  justify-between flex-wrap">
        {/* Website Name */}
        <div className="flex items-center flex-shrink-0 mr-6">
          <Link to="/" className="text-2xl font-bold tracking-wide">
            Masakan Kekinian
          </Link>
        </div>
        {/* Navbar Menu */}
        <div className="flex items-center">
          <div className="md:flex hidden">
            <Link to="/" className="mr-6">
              {t("nav.home")}
            </Link>
            <Link to={`/search/random/all`} className="mr-6">
              {t("nav.recipes")}
            </Link>
            <Link to="/about" className="mr-6">
              {t("nav.about")}
            </Link>
          </div>
          {/* Language Toggle */}
          <div className="flex items-center text-sm" aria-label="Language">
            <button
              type="button"
              onClick={() => setLang("en")}
              className={langButtonClass("en")}
            >
              EN
            </button>
            <span className="mx-1 text-gray-500">|</span>
            <button
              type="button"
              onClick={() => setLang("id")}
              className={langButtonClass("id")}
            >
              ID
            </button>
          </div>
          {/* End of Language Toggle */}
        </div>
        {/* End of Navbar Menu */}
      </div>
    </nav>
  );
};

export default NavBar;
